import ActivityInvoicePage from "./ActivityInvoicePage";

export default ActivityInvoicePage;